import { useSelector } from "react-redux";

import { MainContent } from "shared/styles";
import {
  ContactDetails,
  Documents,
  Preferences,
  ProfileSummary,
} from "Bands/containers";
import { Spacer } from "shared/layout";
import {
  FullUserProfileProvider,
  UserProvider,
  useUserContext,
} from "Bands/contexts";
import { mapUserPermissions } from "shared/utils";
import { FourOhThree } from "shared/pages";
import { Loader } from "shared/components";
import { dataMetaSelector } from "Bands/state";
import { USER_ACTIONS } from "Bands/types";
import { IAPIState } from "shared/types";

const Component = () => {
  const { bandUser, user } = useUserContext();

  const { api: apiMeta } = useSelector(dataMetaSelector(USER_ACTIONS.getUser));

  if (!user && apiMeta?.status === IAPIState.pending) return <Loader />;
  if (!mapUserPermissions(bandUser?.permissions || []).VIEW_FULL_PROFILE)
    return <FourOhThree />;

  return (
    <FullUserProfileProvider user={user}>
      <MainContent>
        <Spacer size="s">
          <ProfileSummary />
          <ContactDetails />
          <Documents />
          <Preferences />
        </Spacer>
      </MainContent>
    </FullUserProfileProvider>
  );
};

export const ViewFullProfilePage = () => (
  <UserProvider>
    <Component />
  </UserProvider>
);
